import { CheckoutResponse } from '../types/subscription';
import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

const SubscriptionsAPI = {

  createCheckoutOrPortal: (planId: string) => {
    return APIClient(CONFIG.API_ENDPOINT).post<CheckoutResponse>('/v1/subscriptions/checkout-or-portal', {
      planId
    });
  },

  getCurrentSubscription: () => {
    return APIClient(CONFIG.API_ENDPOINT).get('/v1/subscriptions/current');
  }
};

export default SubscriptionsAPI;
